import { useContext } from 'react';
import { DeleteModal, ModalContext } from 'dash-ui';

import { GetUnitsDocument, useDeleteUnitMutation } from 'gql/generated.graphql';

const DeleteInventoryModal = () => {
  const { payload } =
    useContext(ModalContext);
    const [deleteMutation, { loading }] = useDeleteUnitMutation({
      refetchQueries: [GetUnitsDocument],
    });

  const onSubmit = async () => {
    await deleteMutation({ variables: { unitId: payload?._id } })
  };

  return (
    <DeleteModal
      entity="Inventory"
      name={payload?.name}
      isLoading={loading}
      modalName="DeleteInventoryModal"
      onClick={onSubmit}
      colorVariation="danger"
    />
  );
};

export default DeleteInventoryModal;
